import type { FC, ReactNode } from 'react'
import React, { useContext, useMemo } from 'react'

import type { ListContext } from './types'

/**
 * @ignore - internal component.
 */
const Context = React.createContext<ListContext>({})

if (process.env.NODE_ENV !== 'production') {
  Context.displayName = 'ListContext'
}

export const ListContextProvider: FC<
  ListContext & {
    children: ReactNode
  }
> = props => {
  const { variant, dense, children } = props
  const context = useMemo(() => ({ variant, dense }), [dense, variant])
  return <Context.Provider value={context}>{children}</Context.Provider>
}

export const useListContext = (): ListContext => useContext(Context)
